import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import CookieConsentPolicy from './core/CookieConsentPolicy';
import SVBMedaliaSurvey from './core/SVBMedaliaSurvey';
const baseUrl = window.location.host;

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <CookieConsentPolicy baseUrl={baseUrl} />
    <SVBMedaliaSurvey
      enabled={
        process.env.REACT_APP_MEDALIA_ENABLE &&
        process.env.REACT_APP_MEDALIA_ENABLE.toLowerCase() === 'true'
          ? true
          : false
      }
    />
  </React.StrictMode>,
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
